"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useChatInfo = exports.useChatInfoWithChat = void 0;
var react_1 = __importDefault(require("react"));
var use_chat_1 = require("./use-chat");
var use_chat_driver_1 = require("./use-chat-driver");
function determineChatInfo(chat, userId) {
    var _a, _b, _c, _d;
    if (chat == null)
        return null;
    if (chat.type === 'interpersonal') {
        var other = chat.members.find(function (u) { return u.userId !== userId; });
        return {
            type: 'person',
            label: (_a = other === null || other === void 0 ? void 0 : other.name) !== null && _a !== void 0 ? _a : '',
            profilePictureSrc: (_b = other === null || other === void 0 ? void 0 : other.profilePictureSrc) !== null && _b !== void 0 ? _b : '',
            unread: chat.unread,
            userId: (_c = other === null || other === void 0 ? void 0 : other.userId) !== null && _c !== void 0 ? _c : ''
        };
    }
    else {
        return {
            type: 'channel',
            label: (_d = chat.label) !== null && _d !== void 0 ? _d : 'Unnamed Channel',
            profilePictureSrc: null,
            unread: chat.unread
        };
    }
}
function useChatInfoWithChat(chat, _a) {
    var self = _a.self;
    return react_1["default"].useMemo(function () { return determineChatInfo(chat, self.userId); }, [chat, self.userId]);
}
exports.useChatInfoWithChat = useChatInfoWithChat;
function useChatInfo() {
    var chatDriver = react_1["default"].useContext(use_chat_driver_1.ChatDriverContext);
    if (chatDriver == null) {
        throw new Error('ChatDriverContext not found');
    }
    var chat = (0, use_chat_1.useChat)().chat;
    return useChatInfoWithChat(chat, { self: chatDriver.self });
}
exports.useChatInfo = useChatInfo;
